import {graphql, Link, useStaticQuery} from "gatsby"
import React from "react"
import {useLocation} from "react-router";
import {Box} from "@mui/material";
import {getLangs} from "./common";

const {languages, defaultLanguage, allLanguages} = require('../../languages');

const Navbar = ({as, pageContext}) => {
    const locale = pageContext?.i18n?.language ?? 'en';

    const langs = getLangs(pageContext);

    return (
        <div
            className={`site-header__header-one site-header__home-two-wrap ${
                as !== "home" ? "header-bg-color" : ""
            }`}
        >
            <div className="topbar-one">
                <div className="container-fluid">
                    <div className="topbar-one__left">
                        <a
                            href="mailto:info@find-my-beach.com"
                            target="_blank"
                            rel="noreferrer"
                        >
                            info@find-my-beach.com
                        </a>
                        <a href="mailto:beach@poi-nt.com" target="_blank" rel="noreferrer">
                            beach@poi-nt.com
                        </a>
                    </div>
                    <div className="topbar-one__right">
                        <div className="topbar-one__social">
                            <a
                                href="https://www.facebook.com/Find-My-Beach-110276687409669"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fab fa-facebook-square"></i>
                            </a>
                            <a
                                href="https://www.instagram.com/find.my.beach/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a
                                href="mailto:info@find-my-beach.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i className="fa fa-envelope"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <header className="main-nav__header-one site-header__home-two ">
                <nav className="header-navigation stricky">
                    <div className="container justify-content-between">
                        <div className="main-nav__logo-box w-auto">
                            <Link to="/" className="main-nav__logo">
                                <img
                                    src="https://strapi.beach.poi-nt.com/uploads/find_my_beach_logo_f51a4d0c50.png"
                                    className="main-logo"
                                    alt="Find My Beach"
                                />
                            </Link>
                            <a href="#" className="side-menu__toggler">
                                <i className="fa fa-bars"></i>
                            </a>
                        </div>
                        <div className="main-nav__main-navigation">
                            <ul className=" main-nav__navigation-box">
                                <li>
                                    <Link to="/about" className="main-nav__logo">
                                        About
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/articles" className="main-nav__logo">
                                        Articles
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${locale}/blog`} className="main-nav__logo">
                                        Blog
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <Box className="main-nav__right ml-3" sx={{minWidth: 50}}>
                            {pageContext?.i18n?.languages?.length > 0 && (
                                <select name="languages" id="languages" onChange={(elem) => {
                                    const lang = langs.find((item) => item.locale === elem.target.value);
                                    if (lang?.url) {
                                        window.location.href = lang.url;
                                    }
                                }} className="selectpicker" defaultValue={locale}>
                                    {langs.map((lang) => (
                                        <option key={lang.locale} value={lang.locale}>{lang.label}</option>))}
                                </select>)}
                        </Box>
                    </div>
                </nav>
            </header>
        </div>
    )
}

export default Navbar
